import { createAuthClient } from "better-auth/react";

const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:4000",
});

export const { useSession, signIn, signOut, resetPassword } = authClient;
export const requestPasswordReset = authClient.requestPasswordReset;
